<template>
  <div class="fillcontain">
    <head-top></head-top>
    <div class="table_container">
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-form :inline="true" :model="filters">
          <el-form-item>
            <el-form-item>
              <el-select v-model="filters.channel" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-form-item>
              <el-select v-model="filters.member" placeholder="请选择">
                <el-option
                  v-for="item in options2"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form-item>
          <el-form-item label >
            <el-input v-model="filters.name" placeholder="用户呢称" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchQuery()">查询</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-table
        :data="tableData"
        style="width: 100%">
        <el-table-column
          label="序号"
          type="index"
          width="70">
        </el-table-column>
        <el-table-column
          label="用户昵称"
          prop="userName">
        </el-table-column>
        <el-table-column
          label="分类"
          prop="userName">
          <template slot-scope="scope">
            <span v-if="scope.row.member==0">普通用户</span>
            <span v-if="scope.row.member==1">VIP用户</span>
          </template>
        </el-table-column>
      
        <el-table-column
          label="渠道来源"
          prop="insertTime">
          <template slot-scope="scope">
            <span v-if="scope.row.identityValid=='d'">纸箱哥-公众号</span>
            <span v-if="scope.row.identityValid=='e'">纸箱哥-VIP介绍</span>
          </template>
        </el-table-column>
        <el-table-column
          label="付费金额"
          prop="payPrice">
          <template slot-scope="scope">
            <span v-if="scope.row.payPrice==0"></span>
            <span v-if="scope.row.payPrice!=0">{{scope.row.payPrice}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="付费时间"
          prop="payTime">
          <template slot-scope="scope">
            <span v-if="scope.row.payTime==0"></span>
            <span v-if="scope.row.payTime!=0">{{scope.row.payTime | formatDate}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="注册时间"
          :formatter="formatDate"
          prop="createTime">
        </el-table-column>
      </el-table>
      <div class="Pagination">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="20"
          layout="total, prev, pager, next"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import headTop from '../components/headTop'
  import { getChannelList } from "../api/api"
  import { formatDate } from "../api/formatDate"
  export default {
    data () {
      return {
        filters: {
          channel:'',
          member:'',
          name: ''
        },
        options:[{
          value: '',
          label: '全部来源',
        }, {
          value: 'd',
          label: '纸箱哥-公众号',
        }, {
          value: 'e',
          label: '纸箱哥-VIP介绍',
        }],
        options2:[{
          value: '',
          label: '全部用户',
        }, {
          value: '0',
          label: '普通用户',
        }, {
          value: '1',
          label: 'VIP用户',
        }],
        tableData: [],
        limit: 20,
        total: 0,
        currentPage: 1,
      }
    },
    filters: {
      formatDate(time) {
        var date = new Date(time*1000);
        return formatDate(date, 'yyyy-MM-dd h:m:s');
      }
    },
    components: {
      headTop,
    },
    methods: {
      //时间戳转换
      formatDate: function (value) {
        var dateee = new Date(value.createTime*1000).toJSON();
        return new Date(+new Date(dateee) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
      },
      handleCurrentChange (val) {
        this.currentPage = val;
        this.searchQuery()
      },
      searchQuery () {
        let params = {
          pageNum: this.currentPage,
          pageSize : this.limit,
          identityValid:this.filters.channel,
          member:this.filters.member,
          userName:this.filters.name
        };
        getChannelList(params).then(res => {
          this.tableData = res.pageInfo
          this.total = res.total
        }).catch(error => {
          console.log(error);
        })
      },
    },
    created (){
      this.searchQuery()
    },
  }
</script>

<style lang="less">
  @import '../style/mixin';
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
</style>



// WEBPACK FOOTER //
// src/page/channel.vue